// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__sNaX8","container":"BaseLayout_container__wHiE1","light":"BaseLayout_light__ldtJE","dark":"BaseLayout_dark__km+Xv"};